module.exports = __webpack_public_path__ + "static/media/p2008mot5.cca073a4.jpg";